<template>
	<div class="leaveMessage">
		<el-select v-model="type" placeholder="留言者身份" class="search">
	      <el-option label="全部" value="0"></el-option>
	      <el-option label="投稿人留言" value="1"></el-option>
	      <el-option label="审核员留言" value="2"></el-option>
	    </el-select>
		<el-select v-model="sort" placeholder="排序" class="search search2">
	      <el-option label="按创建时间降序" value="1"></el-option>
	      <el-option label="按创建时间升序" value="2"></el-option>
	    </el-select>
	    <el-button type="primary" icon="el-icon-search" class="search search3" @click='search'>搜索</el-button>
	    
	    <div class="letter-div" v-for="(item,index) in items" :key='index'>
			<div class="div" :style="{boxShadow:'5px 5px 5px '+item.color}">
				<img class="personIcon" :src="imgUrl" v-if="item.type == 1"/>
				<img class="personIcon" src="../assets/img/admin.png" v-else/>
				<p class="time">{{item.created_at}} <span @click="replay(item)" style="color: dodgerblue;cursor: pointer;">回复</span></p>
				<div class="rightMsg">
					<p v-if="item.type == 1">我</p>
					<p v-else><span>管理员 </span> | <span>{{item.checker}} </span></p>
				    <p class="msgOver">{{item.message}}</p>

				    <!--子循环-->
				    <div class="letter-div-1" v-for="(child,index) in item.child" :key='index'>
						<div class="div1">
							<img class="personIcon" :src="imgUrl" v-if="child.type == 1"/>
							<img class="personIcon" src="../assets/img/admin.png" v-else/>
							<p class="time">{{child.created_at}} <span @click="replay(item)" style="color: dodgerblue;cursor: pointer;">回复</span></p>
							<div class="rightMsg1">
								<p v-if="child.type == 1">我</p>
								<p v-else><span>管理员 </span> | <span>{{child.checker}} </span></p>
							    <p class="msgOver1" style="cursor: auto;">{{child.message}}</p>
							</div>				
						</div>			
					</div>
				</div>				
			</div>			
		</div>
		<el-pagination  @size-change="handleSizeChange"  @current-change="handleCurrentChange"  :page-size="pageSize"  layout="prev, pager, next, jumper"  :total="total" class="pagination"></el-pagination>
		<form v-auto-focus="focusCtrl" :data-current="currentIndex" :data-action="actionType">
	        <el-input @focus="setFocusIndex(0)" type="textarea" v-model="content" class="inputName area" rows="5" data-index="0"></el-input>
	   </form>
		<el-button type="primary" round class="commitFirst" @click="commit">提交留言</el-button>
	</div>
</template>

<script>
	import axios from 'axios'
	import { mapGetters } from 'vuex'
	export default{
		data(){
			return{
				sort:'1',
				type:'0',
				items:[],
				content:'',
				data:'',
				reply:false,
				id:0,
				children:[],
				i:0,
				pageSize:2,
				page:1,
				total:0,
				show:false,
				focusCtrl: 0,  // 自动聚焦控制,变动时,执行自动聚焦指令
                currentIndex: 0, // 当前聚焦元素的索引
                actionType: 'next', // 自动聚焦的行为类型
			}
		},
		computed:{
			...mapGetters([
					'imgUrl','name'
				]),
		},
		created(){
			this.data =this.$route.query.id 
			this.init(this.sort,this.type,this.page,this.pageSize)
		},
		methods:{
			init(sort,type,page,pageSize){
				var data = this.data
				/*var form = new FormData 
				form.append('aid',data.id)
				form.append('sort',sort)
				form.append('type',type)
				form.append('page',page)
				form.append('pageSize',pageSize)*/
				axios({
					method:'get',
					url:process.env.BASE_URL+'/message/lists?aid='+data+'&sort='+sort+'&type='+type+'&page='+page+'&pageSize='+pageSize+'',
					// data:form,
					withCredentials:true
				}).then(res =>{
					this.items = res.data.data.rows.slice((page-1)*pageSize,page*pageSize)
					this.total = res.data.data.rows.length
				})
				
			},
			search(){
				this.init(this.sort,this.type,this.page,this.pageSize)
			},
			commit(){				
				if (this.reply == false) {
					var form1 = new FormData
					form1.append('aid',this.data.id)
					form1.append('message',this.content)
					axios({
						method:'post',
						url:process.env.BASE_URL+'/message/add',
						data:form1,
						withCredentials:true
					}).then(res =>{
						this.init(this.sort,this.type,this.page,this.pageSize)
						this.content = ''
					})
				} else if (this.reply == true) {
					var form2 = new FormData
					form2.append('id',this.id)
					form2.append('aid',this.data.id)
					form2.append('message',this.content)
					axios({
						method:'post',
						url:process.env.BASE_URL+'/message/reply',
						data:form2,
						withCredentials:true
					}).then(res =>{
						if(res.data.code == 10000){
							this.init(this.sort,this.type,this.page,this.pageSize)
						    this.$message('回复成功')
						    this.content = ''
						}
					})
				}
			},
			replay(obj){
				this.reply = true
				this.id = obj.id
				if (obj.type == 1) {
					this.content = '@我: '
					this.focusCtrl = 0
					this.currentIndex = 0
					this.setFocus()
					this.setFocusIndex()
				} else{
					this.content = '@管理员|'+obj.checker+': '
					this.focusCtrl = 0
					this.currentIndex = 0
				}
				
			},
			list(item){	
				axios({
					method:'post',
					url:process.env.BASE_URL+'/message/reply-list?id='+item.id,
					withCredentials:true
				}).then(res =>{
					for (var i = 0; i < this.items.length; i++) {
						if (this.items[i].id == item.id) {
							this.i = i
						}
					}
					this.items[this.i].children = res.data.data.childMsg
					this.items.push()
				})
				if (item.change == true) {
					item.change = false					
				    this.items.push()
				} else if(item.change == false){
					item.change = true					
				    this.items.push()
				} else if(item.change == undefined){
					item.change = true
					this.items.push()
				}
				
			},
			setFocus(actionType,index) {
                if (actionType === 'jump') {
                    this.currentIndex = index
                }
                this.focusCtrl++
                this.actionType = actionType
           },
            setFocusIndex(index) {
                this.currentIndex = index
            },
            handleSizeChange(val) {
		        console.log(`每页 ${val} 条`);
		    },
		    handleCurrentChange(val) {
		       this.init(this.sort,this.type,val,this.pageSize)
		       this.page = val
		    },
		}
	}
</script>

<style scoped>
	.leaveMessage{
		padding-top: 110px;
	}
	.search{
		position: absolute;
		top: 60px;
		right: 100px;
		width: 160px;
	}
	.search2{
		right: 270px;
	}
	.search3{
		right: 0;
		width: 90px;
	}
	.personIcon{
		width: 50px;
		height: 50px;
		float: left;
		padding: 10px;
	}
	.div{
		background: white;
		box-shadow: 5px 5px 5px gray;
		position: relative;
		margin-top: 30px;
		width: 770px;
		margin-left: 35px;
		padding-bottom: 10px;
	}
	.rightMsg{
		width: 600px;
		/*margin-left: 90px;*/		
	}
	.time{
		float: right;
		margin-right: 10px;
	}
	.letter-div-1 .div1{
		width: 700px;
		padding-bottom: 10px;
		margin-left: 30px;
		box-shadow: 1px 1px 1px gray;
	}
	.area{
		width: 770px;
		display: block;
		margin: 0 auto;
		margin-top: 50px;
	}
	.commitFirst{
		margin: 20px auto;
		text-align: center;
		display: block;
	}
	.pagination{
		padding-top: 30px;
		padding-left: 40px;
	}
	.msgOver{
		cursor: pointer;
		width: 700px;
		word-break:break-all;
		display: -webkit-box;
	    -webkit-line-clamp: 1;
	    -webkit-box-orient: vertical;
	    overflow: hidden;
	}
	.active{
		overflow: auto;
		display: block;
	}	
	.msgOver1{
		cursor: pointer;
		width: 700px;
		word-break:break-all;
		display: -webkit-box;
	    -webkit-line-clamp: 100000;
	    -webkit-box-orient: vertical;
	}
</style>


// WEBPACK FOOTER //
// src/views/leaveMessage.vue